import { render, staticRenderFns } from "./DSPAccountData.vue?vue&type=template&id=2aa994ac"
import script from "./DSPAccountData.vue?vue&type=script&lang=js"
export * from "./DSPAccountData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports